<template>
  <div class="cursor-pointer" @click="showIntroGuide">
    <Tooltip tooltipText="Help!" position="-top-8 right-1" />
    <QuestionMarkCircleIcon
      v-if="currentRoute.meta?.intro"
      class="h-10 w-10 text-sm font-medium"
      :class="iconClass"
    />
  </div>
</template>
<script lang="ts" setup>
import { nextTick, ref } from "vue";
import { IntroGuideName, IntroGuideRoute } from "@/helpers/guide";
import introJs from "intro.js";
import { useRouter } from "vue-router";
import { ContactsTabs } from "@/helpers/subMenus";

defineProps({
  iconClass: {
    type: String,
    default: "text-primary-700 hover:text-primary-700",
  },
});
const { currentRoute } = useRouter();
const intro = ref();
const showIntroGuide = () => {
  intro.value = introJs;
  nextTick(() => {
    const guide: any = {
      [IntroGuideName.CONTACTS_MAIN_PAGE]: [
        {
          element: document.getElementById("contacts_tab"),
          intro:
            "This is the Contacts page where you can manage and view contact-related details.",
        },
        {
          element: document.getElementById("contacts-row[1]_kebabBtn"),
          intro:
            "This kebab menu allows you to perform actions like marking favorites, editing, deleting, or changing contact-level settings.",
        },
        {
          element: document.getElementById("addContact_btn"),
          intro: "Click this button to add a new contact.",
        },
      ],
      [IntroGuideName.CONTACT_GROUPS_MAIN_PAGE]: [
        {
          element: document.getElementById("contact-groups_tab"),
          intro:
            "This is the ContactGroups page where you can manage ContactGroups.",
        },
        {
          element: document.getElementById("addContactGroup_btn"),
          intro: "Click this button to add a new ContactGroup.",
        },
      ],
      [IntroGuideName.CONTACT_FILTERS_MAIN_PAGE]: [
        {
          element: document.getElementById("contact-filter-name_field"),
          intro: "Enter the name of your FilterGroup here.",
        },
        {
          element: document.getElementById("contact-filter-description_field"),
          intro: "Provide a description for your FilterGroup here.",
        },
      ],
      [IntroGuideName.CONTACT_FILTERS_EDIT_MAIN_PAGE]: [
        {
          element: document.getElementById("select-filters_step"),
          intro:
            "In this step, you can modify the search criteria for your FilterGroup.",
        },
        {
          element: document.getElementById("preview_step"),
          intro: "Preview the contacts that match your search criteria here.",
        },
        {
          element: document.getElementById("address-criteria_step"),
          intro:
            "Set the address-related conditions for your FilterGroup in this step.",
        },
        {
          element: document.getElementById("confirmation_step"),
          intro: "This final step confirms the changes to your FilterGroup.",
        },
        {
          element: document.getElementById("contact-filter-builder-field"),
          intro:
            "Select a contact field from this dropdown to define a filtering condition.",
        },
        {
          element: document.getElementById("contact-filter-builder-operator"),
          intro:
            "This dropdown will display relevant operators based on the selected field type.",
        },
        {
          element: document.getElementById("contact-filter-builder-value"),
          intro: "Enter the value to be used in the filtering condition.",
        },
        {
          element: document.getElementById("contact-filter-builder-and-or"),
          intro:
            "Use this to specify logical conditions (AND/OR) between multiple filters.",
        },
        {
          element: document.getElementById("add-filter_btn"),
          intro:
            "Click here to add a new filter row with a field, operator, value, and condition.",
        },
        {
          element: document.getElementById("add-filter-group_btn"),
          intro:
            "Use this to group multiple conditions together to build complex filters.",
        },
      ],
    };

    if (currentRoute.value.meta?.intro) {
      const routeIntro: any = currentRoute.value.meta?.intro;
      let moduleName = "";
      switch (routeIntro) {
        case IntroGuideRoute.CONTACTS:
          moduleName = checkContactsModule();
          break;
        case IntroGuideRoute.CONTACT_FILTER_EDIT:
          moduleName = IntroGuideName.CONTACT_FILTERS_EDIT_MAIN_PAGE;
          break;
        default:
          break;
      }
      intro
        .value()
        .setOptions({
          steps: guide[moduleName].filter(
            (moduleSteps: any) => moduleSteps.element != null,
          ),
        })
        .start();
      intro.value().onbeforeexit(function () {
        intro.value = null;
      });
    }
  });
};

const checkContactsModule = () => {
  const moduleActiveTab = localStorage.getItem("contactsTab");
  switch (moduleActiveTab) {
    case ContactsTabs.CONTACTS:
      return IntroGuideName.CONTACTS_MAIN_PAGE;
    case ContactsTabs.CONTACTS_GROUPS:
      return IntroGuideName.CONTACT_GROUPS_MAIN_PAGE;
    case ContactsTabs.CONTACTS_FILTERS:
      return IntroGuideName.CONTACT_FILTERS_MAIN_PAGE;
    default:
      return IntroGuideName.SAMPLE;
  }
};
</script>
